export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result)
        return
      }

      reject(new Error('Failed to convert file to base64'))
    }

    reader.onerror = () => {
      reject(new Error('Failed to convert file to base64'))
    }

    reader.readAsDataURL(file)
  })

export const getBase64Content = (base64String: string): string => {
  const separator = 'base64,'
  const separatorIndex = base64String.indexOf(separator)

  if (separatorIndex === -1) {
    return base64String
  }

  return base64String.substring(separatorIndex + separator.length)
}
